import { createFeatureConfig } from '@/configs/common/features'

export const featureConfig = createFeatureConfig({
  showAllFeatures: true,
  modules: {
    vesselCard: {
      riskInfo: true,
      sanctions: true,
      violation: false,
    },
    vesselSearch: {
      advanced: false,
    },
    mapLayer: {
      weather: false,
    },
  },
})
